module.exports = __webpack_public_path__ + "img/qr-qxxh.bba76148.png";